import { create } from 'zustand';

interface BulkOnboardingState {
  selectedOrganization: string;
  setSelectedOrganization: (value: string) => void;
}

export const useBulkOnboardingStore = create<BulkOnboardingState>((set) => ({
  selectedOrganization: '',
  setSelectedOrganization: (value) => set({ selectedOrganization: value }),
}));

